import routes from "./routes.js";

/** @type {import("@intellectability/platform-common/router").Route[]} */
let processed = routes.map(function (route) {

    const path = route.action
        ? `?action=${route.action}`
        : route.path + "";
    const render = route.component;
    const secure = route.secure ?? true;
    const title = route.title ?? "";

    return {path, render, secure, title};

});

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: true,
    routes: processed
};

export default routerConfig;

